import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BaseService, EnvironmentService } from 'tnx-shared';

@Injectable({
    providedIn: 'root'
})
export class PermissionService extends BaseService {
    entityName = 'Permission';
    serviceCode = 'Authorization';

    constructor(http: HttpClient, injector: Injector,
        private _environmentService: EnvironmentService) {
        super(http, injector, ``);
        this.endPoint = _environmentService.getHttpServiceEndpointWithVersion(this.serviceCode);
                this.serviceUri = `${this.endPoint}/${this.entityName}`;
    }

    getDetailCustom(id: string, pid: string) {
        const url = `${this.serviceUri}/GetDetailCustom/${id}?pid=${pid}`;
        return this.defaultGet(url);
    }

    GetPermissionsByService(moduleCode) {
        const url = `${this.serviceUri}/GetPermissionsByService?service=${moduleCode}`;
        return this.defaultGet(url);
    }

    // GetPermissionIdByService(moduleCode) {
    //     const url = `${this.serviceUri}/GetPermissionIdByService?service=${moduleCode}`;
    //     return this.defaultGet(url);
    // }

    PhanQuyenNguoiDung(model) {
        const url = `${this.serviceUri}/PhanQuyenNguoiDung`;
        return this.defaultPost(url, model);
    }

    GetIdByUsers(model) {
        const url = `${this.serviceUri}/GetIdByUsers`;
        return this.defaultPost(url, model);
    }

    GetIntersectDirectIdByUsers(model) {
        const url = `${this.serviceUri}/GetIntersectDirectIdByUsers`;
        return this.defaultPost(url, model);
    }


    GetIdByGroupUsers(model) {
        const url = `${this.serviceUri}/GetIdByGroupUsers`;
        return this.defaultPost(url, model);
    }

    GetIntersectDirectIdByGroupUsers(model) {
        const url = `${this.serviceUri}/GetIntersectDirectIdByGroupUsers`;
        return this.defaultPost(url, model);
    }
}
